<template lang="html">
<div v-if="user != null">
  <ul class="pushed-menu d-lg-block d-none" >
    <li v-bind:class="['nav-item', menu.isActive() ? 'active' : '', menu.hasSubMenu() ? 'has-sub-menu' : '']" v-for="(menu, index) in currentPushedApps" v-bind:key="index">
      <a :href="menu.href"><icon :name="menu.icon" v-if="menu.icon" />
        <span class="align-middle">{{ menu.label }}</span><b-badge v-if="menu.badge > 0" class="ml-1  align-middle" pill variant="danger">{{menu.badge}}</b-badge>
      </a>
      <ul class="sub-menu" v-if="menu.hasSubMenu()">
        <li v-for="(sub, subIndex) in menu.subMenu" :key="index+subIndex">
        <a :href="sub.href"><icon :name="sub.icon" v-if="sub.icon" />{{ sub.label }}</a>
        </li>
      </ul>
    </li>
  </ul>
  <!-- Mobile Menu -->
  <div class="d-lg-none d-block">
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand href="#">
        <a href="#">
          <LetterAvatar v-if="user" class="profile-picture" :initials="user.initials()"></LetterAvatar>
          <span class="username" v-if="user && user.role">{{user.lastname}} {{user.firstname}}<br/>
          ({{user.role.libelle}})</span>
        </a>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :href="menu.href" v-bind:class="['nav-item', menu.isActive() ? 'active' : '', menu.hasSubMenu() ? 'has-sub-menu' : '']" v-for="(menu, index) in currentPushedApps" v-bind:key="index">
            <icon :name="menu.icon" v-if="menu.icon" />
            <span class="align-middle">{{ menu.label }}</span><b-badge v-if="menu.badge > 0" class="ml-1  align-middle" pill variant="danger">{{menu.badge}}</b-badge>
          </b-nav-item>
          <b-nav-item>
            <a href="#" v-on:click.prevent.stop="logout" ><icon name="power_settings_new"/>Logout</a>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { USER_LOGOUT } from '@/store/actions/user'
import LetterAvatar from '@/components/LetterAvatar'

export default {
  name: 'PushedMenu',
  components: {
    LetterAvatar
  },
  data: () => ({
    user: null,
    currentPushedApps: [],
    allPushedApps: []
  }),
  computed: {
    ...mapGetters({ pushedApps: 'pushedApps', currentUser: 'user' })
  },
  methods: {
    ...mapActions([USER_LOGOUT]),
    async logout () {
      this.USER_LOGOUT()
      await this.$auth.signOut()
    },
    updateMenu: function () {
      this.allPushedApps.forEach(element => {
        if (this.user.role.code === 'PROJECT_MANAGER' || this.user.role.code === 'CCE') {
          if (element.key !== 'UserList') {
            this.currentPushedApps.push(element)
          }
        } else {
          if (this.user.role.code === 'USER') {
            if (element.key === 'MessagesIndex') {
              this.currentPushedApps.push(element)
            }
          } else {
            this.currentPushedApps.push(element)
          }
        }
      })
    }
  },
  watch: {
    currentUser: {
      deep: true,
      immediate: true,
      handler (newVal) {
        this.user = newVal
        this.updateMenu()
      }
    },
    pushedApps: {
      deep: true,
      immediate: true,
      handler (newVal) {
        this.allPushedApps = newVal
      }
    }
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'
// Mobile menu
.navbar
  a:hover
    color: $white !important
    text-decoration: unset !important
  background-color: $blue
  .navbar-brand  > a
    display: flex
    .username
      padding-top: 0.25rem
      font-size: 0.75rem
  .profile-picture
    margin-right: 0.5rem
  .nav-item
    display: inline-block
    min-width: 12rem
    transition: background-color 0.2s
    font-weight: bold
    font-size: 0.875rem
    text-transform: uppercase
    .material-icons
      margin-right: 0.625rem
      color: rgba($white, 0.8)
    a
      color: $white !important
      &.active, &:hover
          color: rgba($white, 0.5) !important
// End mobile menu
.pushed-menu
  margin: 0
  padding: 0
  list-style: none
  text-align: center

  .nav-item
    display: inline-block
    transition: background-color 0.2s
    font-weight: bold
    font-size: 0.875rem
    text-transform: uppercase

    .material-icons
      margin-right: 0.625rem
      color: rgba($white, 0.8)

    &.active, &:hover
      background-color: $blue-active

      svg
        opacity: 1
      a
        color: $white

  svg
    width: 18px
    opacity: 0.8
    padding-bottom: 3px
    padding-top: 3px
    transition: opacity 0.2s
    fill: rgba($white, 0.8)

  a
    display: inline-block
    padding: 1rem
    height: 100%
    color: rgba($white, 0.8)
    text-decoration: none
    transition: color 0.2s

  .has-sub-menu
    &>a:after
      content: "\e5c5"
      font-family: $font-icon
      padding-left: 1rem
      font-size: 1.5rem
      float: right
      line-height: 1.5rem
      color: rgba($white, 0.8)

    &:hover, &:focus
      &>a:after
        content: "\e5c7"
        font-family: $font-icon

  &>:hover .sub-menu
    display: flex
    opacity: 1

  .sub-menu
    display: none
    justify-content: baseline
    align-items: flex-start
    flex-direction: column
    background-color: $blue-active
    position: absolute
    min-width: 16.375rem
    padding: 0
    text-transform: uppercase
    font-size: 0.75rem
    font-weight: bold
    color: $white
    letter-spacing: 1px
    opacity: 0
    z-index: 1
    box-shadow: 0 8px 9px 0 rgba($black, 0.2)

    li
      width: 100%
      text-align: left
      &:hover
        background-color: rgba($blue-dark, 0.7)


    a
      padding: 1rem

      .material-icons
        fill: rgba($white, 0.6)
        color: rgba($white, 0.6)
        margin-right: 1rem
        font-size: 18px
        padding-right: 15px
        padding-left: 1.5rem
        transition: color 0.2s, fill 0.2s

      &:hover .material-icons
        fill: $white
        color: $white
</style>



// WEBPACK FOOTER //
// src/components/menu/PushedMenu.vue